import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useParams } from 'react-router-dom';
import { database } from '../../Firebase';
import { ref, onValue } from 'firebase/database';

const Namuna7Receipt = ({ transaction: propTransaction, onPrintComplete }) => {
  const { id } = useParams();
  const [transaction, setTransaction] = useState(propTransaction || null);
  const [loading, setLoading] = useState(!propTransaction);

  useEffect(() => {
    if (propTransaction) {
        setTransaction(propTransaction);
        setLoading(false);
        return;
    }
    if (!id) return;
    const txRef = ref(database, `Grampanchayat/Panipuravtha/Transactions/RokhJama/${id}`);
    onValue(txRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setTransaction(data);
      }
      setLoading(false);
    });
  }, [id, propTransaction]);

  useEffect(() => {
    if (!loading && transaction) {
      setTimeout(() => window.print(), 500);
    }
  }, [loading, transaction]);

  if (loading) return <div>Loading...</div>;
  if (!transaction) return <div>Transaction not found</div>;

  const ReceiptCopy = ({ title }) => (
    <div className="border border-black p-4 w-full h-full flex flex-col justify-between text-base">
      <div className="text-center font-bold border-b border-black pb-2 mb-2">
        <h1 className="text-xl mb-1">ग्रामपंचायत इनाम धामणी</h1>
        <h2 className="text-lg mb-1">नमुना ७</h2>
        <h3 className="text-base">सामान्य पावती ({title})</h3>
      </div>

      <div className="flex justify-between mb-2 font-medium">
        <span>दिनांक : {transaction.date?.split('-').reverse().join('/')}</span>
        <span>पावती क्रमांक : {transaction.challanNo || '1'}</span>
      </div>
      <div className="mb-4 font-medium">
        <span>पुस्तक क्रमांक : </span>
      </div>

      <div className="flex-1 mb-4 border-t border-b border-black py-4">
        {transaction.customContent ? (
             <p className="leading-loose">
                <span className="font-bold">{transaction.personName}</span> {transaction.customContent} 
                <span className="font-bold"> {transaction.totalAmount?.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span> मिळाली.
             </p>
        ) : (
            <p className="leading-loose">
            <span className="font-bold">{transaction.personName}</span> कडून 
            <span className="font-bold"> {transaction.voucherType || 'पाणीपुरवठा विद्युत बिलापोटी'}</span>
            (50%) जि.प. कडून च्या खाती रक्कम रुपये 
            <span className="font-bold"> {transaction.totalAmount?.toFixed(2)}</span> मिळाली.
            </p>
        )}
      </div>

      <div className="text-right mt-8 pt-4 font-bold">
        ग्रामपंचायत अधिकारी / क्लार्क
      </div>

      <div className="mt-4 text-xs border-t border-black pt-2">
        <p className="mb-1">टीप -१) ही पावती कार्बन पेपरवरुन काढलेल्या दुहेरी प्रतीची असली पाहिजे.</p>
        <p className="mb-1">२) नमुने देण्यात येतील तेव्हा पुस्तकांचे व पावत्यांचे क्रमांक छापण्यात किंवा शिक्क्याने वटविण्यात आलेले असले पाहिजे.</p>
        <p>३) यथास्थिती ग्रामपंचायत अधिकारी किंवा पंचायतीच्या क्लार्क याने त्यास मिळालेल्या रकमेबद्दल पंचायतीच्या वतीने पावती दिली पाहिजे.</p>
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    <div className="bg-white min-h-screen font-poppins text-black fixed inset-0 z-[9999] overflow-auto">
      <style>{`
        @media print {
          @page {
            size: landscape;
            margin: 0.5cm;
          }
          body * {
            visibility: hidden;
          }
          #printable-receipt, #printable-receipt * {
            visibility: visible;
          }
          #printable-receipt {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }
          .receipt-container {
             display: flex;
             flex-direction: row;
             width: 100%;
             height: 100%;
             gap: 2rem;
          }
          .receipt-box {
            flex: 1;
            border: 1px solid black;
            padding: 1rem;
          }
          .no-print {
            display: none !important;
          }
        }
      `}</style>
       
       {onPrintComplete && (
            <button 
                onClick={onPrintComplete} 
                className="fixed top-4 right-4 bg-red-600 text-white px-4 py-2 rounded shadow no-print z-50 hover:bg-red-700 font-bold"
            >
                Close Preview
            </button>
       )}
      
      <div id="printable-receipt" className="bg-white p-8 h-full flex flex-col justify-center">
        <div className="receipt-container flex flex-col md:flex-row gap-8 h-full max-w-[297mm] mx-auto landscape:h-[210mm]">
            <div className="receipt-box flex-1 h-full">
                 <ReceiptCopy title="Original" />
            </div>
            <div className="receipt-box flex-1 h-full">
                 <ReceiptCopy title="Duplicate" />
            </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Namuna7Receipt;
